// extracted by mini-css-extract-plugin
export default {"container":"IconAndName_container__mdPRy","icon":"IconAndName_icon__xQK0t","title":"IconAndName_title__lqG4u"};